import { PageHeader, message } from "antd";
import { FileExcelOutlined, FolderOutlined, ThunderboltOutlined, ClearOutlined, LineChartOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem } from "../../../Components/Items";
import SelectorModeloReporte from "./SelectorModeloReporte";
import SelectorCamposReporte from "./SelectorCamposReporte";
import SelectorNivelDetalle from "./SelectorNivelDetalle";
import SelectorPeriodoReporte, { calcularRangoPeriodo } from "./SelectorPeriodoReporte";
import PanelFiltrosReporte from "./PanelFiltrosReporte";
import TablaPreviewReporte from "./TablaPreviewReporte";
import GraficaReporte from "./GraficaReporte";
import GestorPlantillasReporte from "./GestorPlantillasReporte";
import exportarExcelReporte from "./exportarExcelReporte";

function EtiquetaSeccion({ children, extra }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "4px 0 8px",
      }}
    >
      <span
        style={{
          fontSize: 11.5,
          fontWeight: 700,
          color: "#8c8c8c",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
        }}
      >
        {children}
      </span>
      {extra}
    </div>
  );
}

class CreadorDeReportes extends Component {
  tableRef = null;
  state = {
    modelos: [],
    modeloKey: null,
    grupos: [],
    catalogoPorKey: {},
    camposSeleccionados: [],
    filtros: {},
    nivelDetalle: "cabecera",
    dataSource: [],
    totalRecords: 0,
    loading: false,
    exportando: false,
    modalPlantillas: false,
    haGenerado: false,
    camposGenerados: [],
    ultimaConsultaSnapshot: null,
    periodoPreset: "mes",
    periodoRango: calcularRangoPeriodo("mes"),
    mostrarGrafica: false,
    plantillaActivaId: null,
    modelosCargados: false,
  };

  componentDidMount() {
    this.cargarModelosDisponibles();
  }

  cargarModelosDisponibles() {
    axios
      .post("creadorDeReportes/modelosDisponibles", {}, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) return message.error("No se pudieron cargar los modelos de reporte");
        const modelos = res.data.modelos || [];
        this.setState({ modelos, modelosCargados: true });
        if (modelos.length > 0) this.cambiarModelo(modelos[0].key);
      });
  }

  campoFechaKeyActual = () => this.state.modelos.find((m) => m.key === this.state.modeloKey)?.campoFechaPrincipal || null;

  soloCompartidosActual = () => !!this.state.modelos.find((m) => m.key === this.state.modeloKey)?.soloCompartidos;

  cambiarModelo = (modeloKey) => {
    const campoFechaKey = this.state.modelos.find((m) => m.key === modeloKey)?.campoFechaPrincipal || null;
    const [desde, hasta] = calcularRangoPeriodo("mes");

    this.setState(
      {
        modeloKey,
        camposSeleccionados: [],
        filtros: campoFechaKey ? { [campoFechaKey]: { desde: desde.toISOString(), hasta: hasta.toISOString() } } : {},
        nivelDetalle: "cabecera",
        haGenerado: false,
        dataSource: [],
        totalRecords: 0,
        periodoPreset: "mes",
        periodoRango: [desde, hasta],
        mostrarGrafica: false,
        plantillaActivaId: null,
      },
      () => this.cargarCatalogo(modeloKey)
    );
  };

  onChangePeriodo = ({ preset, rango }) => {
    const campoFechaKey = this.campoFechaKeyActual();
    const nuevosFiltros = { ...this.state.filtros };
    if (campoFechaKey) {
      if (rango?.[0] && rango?.[1]) {
        nuevosFiltros[campoFechaKey] = { desde: rango[0].toISOString(), hasta: rango[1].toISOString() };
      } else {
        delete nuevosFiltros[campoFechaKey];
      }
    }
    this.setState({ periodoPreset: preset, periodoRango: rango, filtros: nuevosFiltros });
  };

  cargarCatalogo(modeloKey) {
    axios
      .post("creadorDeReportes/catalogo", { modeloKey }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) return message.error("No se pudo cargar el catálogo del reporte");
        const grupos = res.data.grupos || [];
        const catalogoPorKey = {};
        grupos.forEach((g) => g.campos.forEach((c) => (catalogoPorKey[c.key] = c)));
        this.setState({ grupos, catalogoPorKey });
      });
  }

  dispararConsulta = () => {
    if (this.tableRef) this.tableRef.updateExternalFilters({});
  };

  snapshotConsulta = (state = this.state) =>
    JSON.stringify({
      camposSeleccionados: state.camposSeleccionados,
      filtros: state.filtros,
      nivelDetalle: state.nivelDetalle,
    });

  generarReporte = () => {
    if (this.state.camposSeleccionados.length === 0) {
      return message.warning(
        this.soloCompartidosActual()
          ? "Aplica una plantilla compartida para generar el reporte"
          : "Elige al menos un campo para generar el reporte"
      );
    }
    const yaEstabaGenerado = this.state.haGenerado;
    this.setState(
      {
        haGenerado: true,
        camposGenerados: this.state.camposSeleccionados,
        ultimaConsultaSnapshot: this.snapshotConsulta(),
      },
      () => {
        if (yaEstabaGenerado) this.dispararConsulta();
      }
    );
  };

  consultarReporte = (requestBody) => {
    const { modeloKey, camposSeleccionados, filtros, nivelDetalle, haGenerado, plantillaActivaId } = this.state;
    if (!modeloKey || !haGenerado) return;

    this.setState({ loading: true });
    axios
      .post(
        "creadorDeReportes/preview",
        {
          empresaId: this.props.empresaId,
          modeloKey,
          camposSeleccionados,
          filtros,
          nivelDetalle,
          plantillaId: plantillaActivaId,
          page: requestBody.page,
          pageSize: requestBody.pageSize,
          sortField: requestBody.sortField,
          sortOrder: requestBody.sortOrder,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudo generar el reporte");
          return this.setState({ loading: false, dataSource: [], totalRecords: 0 });
        }
        this.setState({ loading: false, dataSource: res.data.data, totalRecords: res.data.totalRecords });
      })
      .catch(() => this.setState({ loading: false }));
  };

  onChangeCampos = (nuevosKeys) => {
    this.setState({ camposSeleccionados: nuevosKeys, plantillaActivaId: null });
  };

  limpiarSeleccion = () => {
    if (this.state.camposSeleccionados.length === 0) return;
    this.setState({ camposSeleccionados: [], plantillaActivaId: null });
  };

  onChangeNivelDetalle = (nivelDetalle) => {
    const { catalogoPorKey, camposSeleccionados } = this.state;

    const filtrados = camposSeleccionados.filter((key) => !(nivelDetalle === "cabecera" && catalogoPorKey[key]?.soloDetalle));
    if (filtrados.length !== camposSeleccionados.length) {
      message.warning("Algunos campos elegidos solo están disponibles en modo detalle y se quitaron de la selección.");
    }

    this.setState({ nivelDetalle, camposSeleccionados: filtrados });
  };

  onChangeFiltros = (filtros) => {
    this.setState({ filtros });
  };

  exportarExcel = () => {
    const { modeloKey, camposSeleccionados, filtros, nivelDetalle, plantillaActivaId } = this.state;
    if (camposSeleccionados.length === 0) return message.warning("Elige al menos un campo para exportar");

    this.setState({ exportando: true });
    exportarExcelReporte({
      empresaId: this.props.empresaId,
      modeloKey,
      camposSeleccionados,
      filtros,
      nivelDetalle,
      plantillaId: plantillaActivaId,
      headersToken: this.props.headersToken,
    }).finally(() => this.setState({ exportando: false }));
  };

  aplicarPlantilla = (plantilla) => {
    const yaEstabaGenerado = this.state.haGenerado;
    const nuevoEstado = {
      camposSeleccionados: plantilla.camposSeleccionados || [],
      filtros: plantilla.filtros || {},
      nivelDetalle: plantilla.nivelDetalle || "cabecera",
    };

    const campoFechaKey = this.campoFechaKeyActual();
    const rangoGuardado = campoFechaKey && nuevoEstado.filtros[campoFechaKey];
    if (rangoGuardado?.desde && rangoGuardado?.hasta) {
      nuevoEstado.periodoPreset = "personalizado";
      nuevoEstado.periodoRango = [moment(rangoGuardado.desde), moment(rangoGuardado.hasta)];
    }

    this.setState(
      {
        ...nuevoEstado,
        modalPlantillas: false,
        haGenerado: true,
        camposGenerados: nuevoEstado.camposSeleccionados,
        ultimaConsultaSnapshot: this.snapshotConsulta({ ...this.state, ...nuevoEstado }),
        plantillaActivaId: plantilla._id,
      },
      () => {
        if (yaEstabaGenerado) this.dispararConsulta();
      }
    );
    message.success(`Plantilla "${plantilla.nombre}" aplicada`);
  };

  render() {
    const {
      modelos,
      modeloKey,
      grupos,
      catalogoPorKey,
      camposSeleccionados,
      nivelDetalle,
      dataSource,
      totalRecords,
      loading,
      exportando,
      haGenerado,
      camposGenerados,
      periodoPreset,
      periodoRango,
      mostrarGrafica,
      modelosCargados,
    } = this.state;

    const sinAcceso = modelosCargados && modelos.length === 0;

    const camposSeleccionadosFiltrables = camposSeleccionados.map((k) => catalogoPorKey[k]).filter(Boolean);
    const camposSoloFiltro = Object.values(catalogoPorKey).filter((c) => c.soloFiltro);
    const camposFiltrosVisibles = [...camposSeleccionadosFiltrables, ...camposSoloFiltro].filter(
      (c, index, arr) => arr.findIndex((c2) => c2.key === c.key) === index
    );

    const hayCambiosSinAplicar = haGenerado && this.state.ultimaConsultaSnapshot !== this.snapshotConsulta();
    const campoFechaKey = this.campoFechaKeyActual();
    const soloCompartidos = this.soloCompartidosActual();
    const camposNumericosParaGrafica = camposGenerados
      .map((k) => catalogoPorKey[k])
      .filter((c) => c && (c.tipo === "numero" || c.tipo === "moneda") && !c.soloDetalle);

    return (
      <>
        <PageHeader
          title="Creador de Reportes"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              <ButtonItem
                blanco
                className="botonAgregar"
                icon={<FolderOutlined />}
                onClick={() => this.setState({ modalPlantillas: true })}
                disabled={sinAcceso}
              >
                Plantillas
              </ButtonItem>
              <ButtonItem
                type="primary"
                cyan
                className="botonAgregar"
                icon={<FileExcelOutlined />}
                loading={exportando}
                onClick={this.exportarExcel}
                disabled={sinAcceso || !haGenerado || camposSeleccionados.length === 0}
              >
                Descargar Excel
              </ButtonItem>
            </>
          }
        />
        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            paddingBottom: 90,
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
            border: "1px solid rgb(235, 237, 240)",
          }}
        >
          {sinAcceso ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#8c8c8c" }}>
              No tienes acceso a ningún modelo de este Creador de Reportes. Pide que te asignen el permiso correspondiente.
            </div>
          ) : (
            <>
          <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
            <SelectorModeloReporte modelos={modelos} value={modeloKey} onChange={this.cambiarModelo} />
            <SelectorNivelDetalle value={nivelDetalle} onChange={this.onChangeNivelDetalle} disabled={soloCompartidos} />
            <div style={{ flex: 1 }} />
            {hayCambiosSinAplicar && (
              <span style={{ fontSize: 12, color: "#fa8c16", fontWeight: 600 }}>
                Tienes cambios sin aplicar ⚠
              </span>
            )}
            <ButtonItem
              type="primary"
              olivo={!hayCambiosSinAplicar}
              naranja={hayCambiosSinAplicar}
              className="botonAgregar"
              icon={<ThunderboltOutlined />}
              onClick={this.generarReporte}
            >
              Generar Reporte
            </ButtonItem>
          </div>

          {campoFechaKey && (
            <>
              <EtiquetaSeccion>Periodo</EtiquetaSeccion>
              <div style={{ marginBottom: 16, maxWidth: 560 }}>
                <SelectorPeriodoReporte preset={periodoPreset} rango={periodoRango} onChange={this.onChangePeriodo} />
              </div>
            </>
          )}

          {soloCompartidos ? (
            <div
              style={{
                marginBottom: 16,
                padding: "10px 14px",
                backgroundColor: "#fafafa",
                borderRadius: 8,
                border: "1px solid #f0f0f0",
                fontSize: 13,
                color: "#595959",
              }}
            >
              Solo puedes ver reportes de plantillas que otro usuario haya compartido contigo.{" "}
              <ButtonItem type="link" size="small" style={{ padding: 0, height: "auto" }} onClick={() => this.setState({ modalPlantillas: true })}>
                Abrir plantillas compartidas
              </ButtonItem>.
            </div>
          ) : (
            <>
              <EtiquetaSeccion
                extra={
                  camposSeleccionados.length > 0 && (
                    <ButtonItem size="small" blanco icon={<ClearOutlined />} onClick={this.limpiarSeleccion}>
                      Limpiar selección
                    </ButtonItem>
                  )
                }
              >
                Campos a mostrar
              </EtiquetaSeccion>
              <SelectorCamposReporte
                grupos={grupos}
                nivelDetalle={nivelDetalle}
                value={camposSeleccionados}
                onChange={this.onChangeCampos}
              />
            </>
          )}

          {camposFiltrosVisibles.length > 0 && (
            <>
              <EtiquetaSeccion>Filtros</EtiquetaSeccion>
              <PanelFiltrosReporte
                campos={camposFiltrosVisibles}
                value={this.state.filtros}
                onChange={this.onChangeFiltros}
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
              />
            </>
          )}

          <EtiquetaSeccion
            extra={
              haGenerado &&
              campoFechaKey && (
                <ButtonItem
                  size="small"
                  blanco
                  icon={<LineChartOutlined />}
                  onClick={() => this.setState({ mostrarGrafica: !mostrarGrafica })}
                >
                  {mostrarGrafica ? "Ocultar Gráfica" : "Ver Gráfica"}
                </ButtonItem>
              )
            }
          >
            Resultado
          </EtiquetaSeccion>
          {!haGenerado ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#8c8c8c" }}>
              Elige los campos que quieres ver y presiona <b>Generar Reporte</b>.
            </div>
          ) : (
            <>
              {mostrarGrafica && campoFechaKey && (
                <div style={{ marginBottom: 20, padding: 16, backgroundColor: "#fafafa", borderRadius: 8, border: "1px solid #f0f0f0" }}>
                  <GraficaReporte
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    modeloKey={modeloKey}
                    camposNumericos={camposNumericosParaGrafica}
                    filtros={this.state.filtros}
                    rango={periodoRango}
                    plantillaId={this.state.plantillaActivaId}
                  />
                </div>
              )}
              <TablaPreviewReporte
                ref={(ref) => (this.tableRef = ref)}
                catalogoPorKey={catalogoPorKey}
                camposSeleccionados={camposGenerados}
                dataSource={dataSource}
                totalRecords={totalRecords}
                loading={loading}
                onFetchData={this.consultarReporte}
              />
            </>
          )}
            </>
          )}
        </div>

        <GestorPlantillasReporte
          visible={this.state.modalPlantillas}
          onCancel={() => this.setState({ modalPlantillas: false })}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          modeloKey={modeloKey}
          catalogoPorKey={catalogoPorKey}
          configuracionActual={{
            camposSeleccionados,
            filtros: this.state.filtros,
            nivelDetalle,
          }}
          onAplicar={this.aplicarPlantilla}
          soloCompartidos={soloCompartidos}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(CreadorDeReportes);
